module.exports = new __parcel__URL__("name_screen_btn_enabled.44d29edf.png").toString();